import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor() {}

  // Helper to get the token ONLY if it looks valid
  getValidToken(): string | null {
    // 1. Get token from Local OR Session storage
    let token =
      localStorage.getItem('workNigeriaToken') ||
      sessionStorage.getItem('workNigeriaToken');

    // 2. Sanity Check: A valid JWT must have 3 parts separated by dots (.)
    if (token && token.split('.').length === 3) {
      return token;
    }

    // 3. If it's null or malformed (e.g. user tampered with it), return null
    return null;
  }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const token = this.getValidToken();
    const isApiUrl = request.url.startsWith(environment.baseUrl);

    // Add excluded URLs here
    const isExcluded =
      request.url === environment.CVpurse_Link ||
      request.url === `${environment.baseUrl}job/get-company`;

    if (token && !isExcluded) {
      request = request.clone({
        setHeaders: {
          authorization: token,
        },
      });
    }

    return next.handle(request);
  }
}
